import { mediaUrl } from "./media-url";

export const TITLE_MENU_HOVER_SOUND_URL = mediaUrl("/assets/audio/title-screen/menu-hover.mp3");
export const TITLE_MENU_CLICK_SOUND_URL = mediaUrl("/assets/audio/title-screen/menu-click.mp3");

type UiCue = {
  source: string;
  voices: HTMLAudioElement[];
  nextVoice: number;
};

type TitleMenuUiAudioBank = {
  hover: UiCue;
  click: UiCue;
};

let titleMenuUiAudioBank: TitleMenuUiAudioBank | undefined;

function createCue(source: string, volume: number): UiCue {
  return {
    source,
    nextVoice: 0,
    voices: Array.from({ length: 3 }, () => {
      const audio = new Audio(source);
      audio.preload = "auto";
      audio.volume = volume;
      audio.load();
      return audio;
    }),
  };
}

function audioBank() {
  if (titleMenuUiAudioBank || typeof Audio === "undefined") return titleMenuUiAudioBank;
  titleMenuUiAudioBank = {
    hover: createCue(TITLE_MENU_HOVER_SOUND_URL, 0.42),
    click: createCue(TITLE_MENU_CLICK_SOUND_URL, 0.62),
  };
  return titleMenuUiAudioBank;
}

/** Loads enough simultaneous voices for fast movement across the title menu. */
export function preloadTitleMenuUiAudio() {
  return Boolean(audioBank());
}

function playCue(cue: UiCue | undefined) {
  if (!cue) return undefined;
  const idleVoice = cue.voices.findIndex((voice) => voice.paused || voice.ended);
  const voiceIndex = idleVoice >= 0 ? idleVoice : cue.nextVoice;
  cue.nextVoice = (voiceIndex + 1) % cue.voices.length;
  const voice = cue.voices[voiceIndex];
  try {
    voice.currentTime = 0;
    void voice.play().catch(() => undefined);
  } catch {
    // Interface sounds must never interrupt navigation.
  }
  return cue.source;
}

export function playTitleMenuHoverSound() {
  return playCue(audioBank()?.hover);
}

export function playTitleMenuClickSound() {
  return playCue(audioBank()?.click);
}
